import React from 'react';
import camelcase from 'camelcase-es5';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TText } from './types';

type TTextBaseProps = {
  kind?:
    | 'body-base-regular'
    | 'body-base-strong'
    | 'body-small-regular'
    | 'body-small-strong'
    | 'body-extra-small-regular'
    | 'body-extra-small-strong'
    | 'action';
} & TText;

const TextBase = ({ as = 'span', kind, color, utilities = [], ...rest }: TTextBaseProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind && camelcase(kind),
    utilities: [color && camelcase(`color-${color}`), ...utilities],
  });

  return <Box {...rest} {...conditionalProps} as={as} name="Text" />;
};

export default React.memo(TextBase);
